
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.06 6.638v14.298C1.06 22.628 2.481 24 4.234 24h9.53c1.754 0 3.176-1.372 3.176-3.064V6.638H1.06zM5.297 20.78c0 .372-.238.672-.531.672h-.532c-.293 0-.531-.3-.531-.672V9.346c0-.358.223-.645.501-.666h.591c.278.021.501.308.501.666V20.78h.001zm4.764 0c0 .372-.237.672-.53.672H8.468c-.293 0-.53-.3-.53-.672V9.346c0-.358.222-.645.5-.666h1.123c.278.021.5.308.5.666V20.78h.002zm4.234-11.434V20.78c0 .372-.237.673-.531.673h-.532c-.293 0-.53-.3-.53-.673V9.346c0-.358.222-.645.5-.666h.591c.28.021.502.308.502.666zm2.645-6.793H1.06C.474 2.553 0 3.01 0 3.574v.51c0 .565.474 1.022 1.06 1.022H16.94c.585 0 1.059-.457 1.059-1.021v-.51c0-.565-.474-1.022-1.059-1.022zM7.751 0h2.687c.585 0 1.058.457 1.058 1.021v.51c0 .565-.474 1.022-1.058 1.022H7.75c-.585 0-1.059-.457-1.059-1.021v-.51C6.692.456 7.166 0 7.752 0z","fill":"#fff"}})])
          )
        }
      }
    